module.exports = __webpack_public_path__ + "img/share.417f4b4e.svg";